<template>
    <div id="app">
        <!-- Container de alertas pra ser usado pelos outros componentes -->
        <alert-container :messages="msgs" />

        <termos-de-uso
            :isShowingTermo="user && user.setTermoPrivacidade == 0"
            v-if="authenticated"
        />

        <loading :isLoading="$store.getters.isLoading" />

        <Header v-if="authenticated" />
        <div class="flex-content" :class="{ 'flex-content-height-menu': authenticated }">
            <Menu v-if="authenticated" />
            <Content />
        </div>
    </div>
</template>

<script>
import TermosDeUso from '@/components/termodeuso/TermosDeUso.vue';
import Message from '@/models/Message.js';
import { mapState } from 'vuex';

// Montagem APP: header, menu e content
import Header from '@/buefy/Header.vue';
import Menu from '@/buefy/Menu.vue';
import Content from '@/buefy/Content.vue';

import 'buefy/dist/buefy.css';
import './assets/css/vendors/materialdesignicons.min.css';
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import '../styles.scss';
import 'normalize.css/normalize.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

export default {
    name: 'WebFV',

    components: {
        TermosDeUso,
        Header,
        Menu,
        Content,
    },
    data() {
        return {
            isSaving: false,
            hasTheme: false,
            favicon: require('@/assets/img/favicon.png'),
            msgs: [],
        };
    },
    computed: {
        ...mapState(['authenticated', 'user']),
    },
    watch: {
        authenticated(val, old) {
            if (old && !val) {
                this.logout();
            }
        },
    },
    created() {
        if (
            this.$cookies.get('token') == null &&
            this.$route.name != 'login' &&
            this.$route.name != null
        ) {
            this.logout();
            return;
        }

        this.mountRootFunctions();

        let faviconElement = document.getElementById('favicon');
        if (this.$store.state.partnerSystemHasLayout.url_icone_web != null) {
            faviconElement.href = this.$store.state.partnerSystemHasLayout.url_icone_web;
        } else {
            faviconElement.href = this.favicon;
        }
        // Define função global que retorna a lingaugem atual do sistema
        window.clang = this.$i18n.locale;

        if (!this.authenticated && this.$route.name != 'login' && this.$route.name != null) {
            this.$router.push({ name: 'login' });
        }
    },
    methods: {
        logout() {
            this.$router.push({ name: 'login' });
            this.$cookies.remove('keepLogged');
            this.$cookies.remove('version');
            this.$cookies.remove('token');
            this.$store.dispatch('user', { value: null });
            this.$store.dispatch('context', { value: null });
            this.$store.dispatch('logoutUser', { value: false });
        },
        mountRootFunctions() {
            console.log('mountRootFunctions');
            this.$root.showMessage = this.showMessage;
            this.$root.confirm = this.confirm;
            this.$root.prompt = this.prompt;
            this.$root.alert = this.alert;
            this.$root.msgs = this.msgs;

            let root = this.$root;

            /* https://developers.google.com/maps/documentation/javascript/events#auth-errors */
            window.gm_authFailure = function () {
                console.error('Houve uma falha de autenticação no Google Maps');
                root.gmapsFailure = true;
            };
        },
        showMessage(type, message, transition, onDict, time) {
            // AlertContainer.vue - AlertMessage.vue
            this.msgs.push(new Message(type, message, transition, onDict, time));
        },
        confirm(options) {
            const { message, onConfirm, onCancel, confirmText = null, cancelText = null } = options;

            this.$buefy.dialog.confirm({
                message: message || this.$t('msg-confirmacao'),
                confirmText: this.$t(confirmText != null ? confirmText : 'sim'),
                cancelText: this.$t(cancelText != null ? cancelText : 'nao'),
                type: 'is-primary',
                hasIcon: true,
                icon: 'alert-circle',
                onConfirm: onConfirm,
                onCancel: onCancel,
            });
        },
        prompt(options) {
            const {
                message,
                onConfirm,
                onCancel,
                confirmText,
                cancelText,
                placeholder,
                required,
            } = options;
            this.$buefy.dialog.prompt({
                message,
                inputAttrs: {
                    type: 'text',
                    required: required != null ? required : true,
                    placeholder,
                },
                confirmText,
                onConfirm,
                cancelText,
                onCancel,
                trapFocus: true,
                closeOnConfirm: true,
            });
        },
        alert(options) {
            const { message, onConfirm } = options;

            this.$buefy.dialog.alert({
                message: message,
                type: 'is-primary',
                onConfirm: onConfirm,
            });
        },
    },
};
</script>

<style lang="scss">
:root {
    --red-alert: #{$red-alert};
    --green-alert: #{$green-alert};
    --blue-alert: #{$blue-alert};
    --orange-alert: #{$orange-alert};
}

html,
body {
    height: 100%;
    padding: 0;
    margin: 0;
}

#app {
    background-color: $bg-color;
    @include defaultFont();
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    display: flex;
    flex-direction: column;

    .flex-content {
        flex-grow: 1;
        display: flex;
        align-items: stretch;
    }
    .flex-content-height-menu {
        height: calc(100% - 50px);
    }
}

.loader {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1;
}
</style>
